import React from "react";
import { z } from "zod";
import { apiPut } from "../../util/axiosUtil";
import API_URL from "../../config/apiConfig";
import MutationHandler from "../../util/MutationHandler";
import { useGeneratedForm } from "../../hooks/useGeneratedForm";
import { DynamicForm } from "../../util/DynamicForm";
// import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Edit = ({ onCancel, userData, onSuccess }) => {
  // const showSuccessToast = (message) => {
  //   toast.success(message, {
  //     position: "top-center",
  //     autoClose: 3000,
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //   });
  // };

  const formFields = {
    name: {
      label: "Name",
      type: "text",
      defaultValue: userData.name,
      required: true,
      valueType: "text",
      validation: z
        .string()
        .min(3, { message: "Name must be at least 3 characters" })
        .refine((val) => !val.includes("error"), {
          message: 'No "error" allowed in name',
        }),
    },
    password: {
      label: "Password",
      type: "text",
      defaultValue: "",
      required: false,
      normalize: (val) => val.replace(/\s+/g, ""),
      valueType: "text",
      validation: z.string().optional(),
    },
  };

  return (
    <MutationHandler
      mutationFn={(formData) =>
        apiPut(`${API_URL}/api/users/update/${userData.id}`, formData)
      }
      onCancel={onCancel}
      onSuccess={onSuccess}
    >
      {(mutation) => (
        <EditUserForm
          formConfig={formFields}
          onSubmit={(value) => mutation.mutate(value)}
          isLoading={mutation.isPending}
          onCancel={onCancel}
        />
      )}
    </MutationHandler>
  );
};

function EditUserForm({ formConfig, onSubmit, isLoading, onCancel }) {
  const form = useGeneratedForm(formConfig, async ({ value }) => {
    onSubmit(value);
  });

  return (
    <DynamicForm
      form={form}
      formConfig={formConfig}
      isLoading={isLoading}
      onCancel={onCancel}
      buttonText={"Edit"}
    />
  );
}

export default React.memo(Edit);
